// Studyo Today Backend
// Package studyo.today.type
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/type/relative_date_kind.proto (package studyo.today.type, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/type/relative_date_kind.proto.
 */
export const file_studyo_today_type_relative_date_kind = /*@__PURE__*/
  fileDesc("CipzdHVkeW8vdG9kYXkvdHlwZS9yZWxhdGl2ZV9kYXRlX2tpbmQucHJvdG8SEXN0dWR5by50b2RheS50eXBlKvMGChBSZWxhdGl2ZURhdGVLaW5kEiIKHlJFTEFUSVZFX0RBVEVfS0lORF9VTlNQRUNJRklFRBAAEh8KG1JFTEFUSVZFX0RBVEVfS0lORF9EQVlTX0FHTxABEiAKHFJFTEFUSVZFX0RBVEVfS0lORF9ZRVNURVJEQVkQAhIcChhSRUxBVElWRV9EQVRFX0tJTkRfVE9EQVkQAxIfChtSRUxBVElWRV9EQVRFX0tJTkRfVE9NT1JST1cQBBIeChpSRUxBVElWRV9EQVRFX0tJTkRfSU5fREFZUxAFEiAKHFJFTEFUSVZFX0RBVEVfS0lORF9EQVlfU0hPUlQQBhIfChtSRUxBVElWRV9EQVRFX0tJTkRfREFZX0xPTkcQBxIgChxSRUxBVElWRV9EQVRFX0tJTkRfV0VFS1NfQUdPEAgSIAocUkVMQVRJVkVfREFURV9LSU5EX0xBU1RfV0VFSxAJEiAKHFJFTEFUSVZFX0RBVEVfS0lORF9USElTX1dFRUsQChIgChxSRUxBVElWRV9EQVRFX0tJTkRfTkVYVF9XRUVLEAsSHwobUkVMQVRJVkVfREFURV9LSU5EX0lOX1dFRUtTEAwSGwoXUkVMQVRJVkVfREFURV9LSU5EX1dFRUsQDRIhCh1SRUxBVElWRV9EQVRFX0tJTkRfTU9OVEhTX0FHTxAOEiEKHVJFTEFUSVZFX0RBVEVfS0lORF9MQVNUX01PTlRIEA8SIQodUkVMQVRJVkVfREFURV9LSU5EX1RISVNfTU9OVEgQEBIhCh1SRUxBVElWRV9EQVRFX0tJTkRfTkVYVF9NT05USBAREiAKHFJFTEFUSVZFX0RBVEVfS0lORF9JTl9NT05USFMQEhIcChhSRUxBVElWRV9EQVRFX0tJTkRfTU9OVEgQExIgChxSRUxBVElWRV9EQVRFX0tJTkRfWUVBUlNfQUdPEBQSIAocUkVMQVRJVkVfREFURV9LSU5EX0xBU1RfWUVBUhAVEiAKHFJFTEFUSVZFX0RBVEVfS0lORF9USElTX1lFQVIQFhIgChxSRUxBVElWRV9EQVRFX0tJTkRfTkVYVF9ZRUFSEBcSHwobUkVMQVRJVkVfREFURV9LSU5EX0lOX1lFQVJTEBgSGwoXUkVMQVRJVkVfREFURV9LSU5EX1lFQVIQGUIZqgIWU3R1ZHlvLlRvZGF5LkdycGMuVHlwZWIGcHJvdG8z");

/**
 * Describes the enum studyo.today.type.RelativeDateKind.
 */
export const RelativeDateKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_type_relative_date_kind, 0);

/**
 * Represents how a date should be displayed by an application.
 *
 * @generated from enum studyo.today.type.RelativeDateKind
 */
export const RelativeDateKind = /*@__PURE__*/
  tsEnum(RelativeDateKindSchema);

